import {type FlowEntity, type NodePosition, type TerminalNode} from '../types'

const NODE_HEIGHT = 32
const NODE_WIDTH = 162
const NODE_GAP = 28
const Y_SPACING = 100
const Y_OFFSET = 50
const X_PADDING = 50
const MAX_ROWS = 3

/** Arranges entities in a grid (max 3 rows) with the terminal node centered below. */
export const createDefaultPositions = (
  entities: FlowEntity[],
  terminalNode: TerminalNode,
  canvasWidth: number
): NodePosition[] => {
  const maxCols = Math.ceil(entities.length / MAX_ROWS)
  const cols = Math.min(entities.length, maxCols)
  const minWidth = cols > 1 ? X_PADDING * 2 + (cols - 1) * (NODE_WIDTH + NODE_GAP) : canvasWidth
  const effectiveWidth = Math.max(canvasWidth, minWidth)
  const availableWidth = effectiveWidth - X_PADDING * 2
  const xSpacing = cols > 1 ? availableWidth / (cols - 1) : 0
  const xOffset = cols > 1 ? X_PADDING : effectiveWidth / 2

  const positions: NodePosition[] = entities.map((entity, i) => ({
    nodeId: entity.id,
    x: xOffset + (i % maxCols) * xSpacing,
    y: Y_OFFSET + Math.floor(i / maxCols) * Y_SPACING
  }))

  const rows = Math.ceil(entities.length / maxCols)
  positions.push({
    nodeId: terminalNode.id,
    x: effectiveWidth / 2,
    y: Y_OFFSET + rows * Y_SPACING + 60
  })

  return positions
}

/** Returns the minimum canvas height needed to fit the entity grid and terminal node. */
export const getCanvasHeight = (entityCount: number): number => {
  if (entityCount === 0) return Y_OFFSET * 2 + NODE_HEIGHT
  const rows = Math.ceil(entityCount / Math.ceil(entityCount / MAX_ROWS))
  return Y_OFFSET + rows * Y_SPACING + 60 + NODE_HEIGHT + Y_OFFSET
}
